import React, { useState } from 'react';
import destinations from '../data/destinationsData';
import './PopularDestinations.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSort, faLink } from '@fortawesome/free-solid-svg-icons';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

console.log("📍 Destination Names:");
const destinationNames = destinations.map(d => d.name);
console.log(destinationNames);

const categoriesList = [
  "City Tour",
  "Beaches",
  "Wildlife",
  "Mountains",
  "Landscape",
  // "Cruises",
  // "Hiking",
  // "Road Trips",
  // "Walking",
  // "Deserts",
  // "Snowfall",
  // "Temples",
  "Adventure",
  "Winter Activities",
  "Kid Friendly",
  "Weekend Getaways",
  "Historical"
];

const monthsList = ["January", "February", "March", "April", "May", "June","July","August","September","October","November","December"];


function PopularDestinations() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState('popular-month');
  const isMobile = window.innerWidth <= 768;
  const perPage = isMobile ? 9 : 15;


  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const defaultCategory = params.get('category');
  const defaultMonth = params.get('month');

  useState(() => {
    if (defaultCategory && categoriesList.includes(defaultCategory)) {
      setSelectedCategory(defaultCategory);
    }
    if (defaultMonth && monthsList.includes(defaultMonth)) {
      setSelectedMonth(defaultMonth);
    }
  }, []);


  const getCurrentMonthName = () => {
    return new Date().toLocaleString('default', { month: 'long' });
  };
  const currentMonth = getCurrentMonthName();

  const filteredDestinations = destinations.filter(dest => {
    const matchesCategory = selectedCategory ? dest.categories.includes(selectedCategory) : true;
    const matchesMonth = selectedMonth ? dest.months.includes(selectedMonth) : true;
    const matchesSearch = dest.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesMonth && matchesSearch;
  });

  const sortedFilteredDestinations = [...filteredDestinations].sort((a, b) => {
    if (sortOption === 'rating') {
      return b.rating - a.rating;
    } else if (sortOption === 'popular-month') {
      const isAInMonth = a.months.includes(currentMonth);
      const isBInMonth = b.months.includes(currentMonth);
      return isBInMonth - isAInMonth;
    } else if (sortOption === 'alphabetical') {
      return a.name.localeCompare(b.name);
    } else {
      return 0;
    }
  });
  

  const paginatedData = sortedFilteredDestinations.slice((currentPage - 1) * perPage, currentPage * perPage);
  const totalPages = Math.ceil(sortedFilteredDestinations.length / perPage);

  return (
    <>
    <Navbar />
    <div className='gap'></div>
    <div className="popular-page">
      <section className="popular-banner">
        <h2>Popular Destinations</h2>
        <p className="breadcrumb">Home → Popular Tours</p>
      </section>

      <div className="popular-container">
        {/* Left Panel */}
        <div className="left-panel">
          <div className="top-controls">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <button>
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
            <div className="sort-dropdown">
              <FontAwesomeIcon icon={faSort} />
              <select
                value={sortOption}
                onChange={(e) => {
                  setSortOption(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="popular-month">Popular This Month ({currentMonth})</option>
                <option value="rating">Sort by Rating</option>
                <option value="alphabetical">Sort A–Z</option>
              </select>
            </div>
          </div>

          {isMobile && (
  <div className="mobile-filters">

    <select
      value={selectedMonth || ''}
      onChange={(e) => {
        const value = e.target.value || null;
        setSelectedMonth(value);
        setCurrentPage(1);
        const newParams = new URLSearchParams(location.search);
        if (selectedCategory) newParams.set('category', selectedCategory);
        if (value) newParams.set('month', value);
        else newParams.delete('month');
        navigate(`${location.pathname}?${newParams.toString()}`);
      }}
    >
      <option value="">All Months</option>
      {monthsList.map(month => (
        <option key={month} value={month}>{month}</option>
      ))}
    </select>

    <select
      value={selectedCategory || ''}
      onChange={(e) => {
        const value = e.target.value || null;
        setSelectedCategory(value);
        setCurrentPage(1);
        const newParams = new URLSearchParams(location.search);
        if (value) newParams.set('category', value);
        else newParams.delete('category');
        if (selectedMonth) newParams.set('month', selectedMonth);
        navigate(`${location.pathname}?${newParams.toString()}`);
      }}
    >
      <option value="">All Categories</option>
      {categoriesList.map(cat => (
        <option key={cat} value={cat}>{cat}</option>
      ))}
    </select>

    

    {/* <select>
      <option value="">Popular Tags</option>
      {["Tour", "Adventure", "Rent", "Innovate", "Hotel", "Modern", "Luxury", "Travel"].map(tag => (
        <option key={tag}>{tag}</option>
      ))}
    </select> */}
  </div>
)}


          <div className="destinations-grid">
            {paginatedData.map(dest => (
              <div key={dest.id} className="destination-card">
                <div className="image" style={{ backgroundImage: `url(${dest.gallery[0]})` }} />
                <div className="info">
                  <h5>{dest.name}</h5>
                  <br></br>
                  {/* <p className="rating"><span className="stars">★★★★★</span> ({dest.rating} Rating)</p> */}
                  {/* <p className="days"><FontAwesomeIcon icon={faClock} /> {dest.days} Days</p> */}
                  <Link to={`/destination/${dest.id}`} className="detail-btn">View Details</Link>
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => setCurrentPage(i + 1)}
                  className={currentPage === i + 1 ? 'active' : ''}
                >
                  {i + 1}
                </button>
              ))}
              {currentPage < totalPages && (
                <button onClick={() => setCurrentPage(currentPage + 1)}>Next →</button>
              )}
            </div>
          )}
        </div>

        {/* Right Panel */}
        <div className="right-panel">

        <div className="filter-block">
            <h4>Months</h4>
            <div className="heading-underline"></div>
            <ul>
              {monthsList.map(month => (
                <li
                  key={month}
                  className={selectedMonth === month ? 'active' : ''}
                  onClick={() => {
                    const newMonth = month === selectedMonth ? null : month;
                    setSelectedMonth(newMonth);
                    setCurrentPage(1);
                    const newParams = new URLSearchParams(location.search);
                    if (selectedCategory) newParams.set('category', selectedCategory);
                    if (newMonth) newParams.set('month', newMonth);
                    else newParams.delete('month');
                    navigate(`${location.pathname}?${newParams.toString()}`);
                  }}
                  
                >
                  <span className="item-left"><FontAwesomeIcon icon={faLink} /> {month}</span>
                  {/* <span className="item-count">(10)</span> */}
                </li>
              ))}
            </ul>
          </div>

          {/* <div className="filter-block">
            <h4>Categories</h4>
            <div className="heading-underline"></div>
            <ul>
              {categoriesList.map(cat => (
                <li
                  key={cat}
                  className={selectedCategory === cat ? 'active' : ''}
                  onClick={() => {
                    const newCategory = cat === selectedCategory ? null : cat;
                    setSelectedCategory(newCategory);
                    setCurrentPage(1);
                    const newParams = new URLSearchParams(location.search);
                    if (newCategory) newParams.set('category', newCategory);
                    else newParams.delete('category');
                    if (selectedMonth) newParams.set('month', selectedMonth);
                    navigate(`${location.pathname}?${newParams.toString()}`);
                  }}
                  
                >
                  <span className="item-left"><FontAwesomeIcon icon={faLink} /> {cat}</span>
                  
                </li>
              ))}
            </ul>
          </div> */}

          

          <div className="filter-card">
            <h4>Categories</h4>
            <div className="tags">
              {categoriesList.map(cat => (
                <span
                  key={cat}
                  className={selectedCategory === cat ? 'tag active' : 'tag'}
                  onClick={() => {
                    const newCategory = selectedCategory === cat ? null : cat;
                    setSelectedCategory(newCategory);
                    setCurrentPage(1);
                    const newParams = new URLSearchParams(location.search);
                    if (newCategory) newParams.set('category', newCategory);
                    else newParams.delete('category');
                    if (selectedMonth) newParams.set('month', selectedMonth);
                    navigate(`${location.pathname}?${newParams.toString()}`);
                  }}
                >
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div className="support-card">
            <h4>Need Help? We Are Here To Help You</h4>
            <div className="logo-rectangle">
              <img src="/logo.png" alt="Sonal Holidays" className="logo-img1" />
            </div>
            <p className="support-text">You Get Online support</p>
            <p className="support-number">+91 97737 49023</p>
            <Link to="/contact" className="support-btn">Contact Us →</Link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default PopularDestinations;
